<template>
  <div class="delivery_oplata">
    <div class="do_title">
      {{ text('screen_form_delivery_method') }}
    </div>
    <div class="delivery_oplata_list">
      <label
        :class="{ dos_block_with_children: deliveryMethod.length > 0 }"
        class="dol_block"
        v-for="deliveryMethod in deliveryMethods"
      >
        <input
          :checked="selectedMethod && deliveryMethod.id === selectedMethod.id"
          :value="deliveryMethod.id"
          name="delivery_service"
          type="radio"
          v-on:change="update(deliveryMethod)"
        />
        <div class="dol_content">
          <div class="dol_inner">
            <div class="dol_name">
              {{ deliveryMethod.name }}
              <span
                class="dos_price"
                v-if="deliveryMethod.value"
                :class="{'ios-font': $store.getters.checkIos}"
              >
                {{ $options.filters.toCurrency(Number(deliveryMethod.value)) }}
              </span>
            </div>
          </div>
        </div>

      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeliveryMethods',
  props: {
    deliveryMethods: Array,
    selectedMethod: Object,
  },
  methods: {
    update(deliveryService) {
      this.$emit('update:selectedMethod', deliveryService)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
